export const FolderSettingService = Symbol.for('FolderSettingService');
